import axios from "axios";
import { API_SERVER, API_PORT } from "../store";
//const API_URL = "http://" + API_SERVER + ":" + API_PORT + "/api/bodega/";
//const API_SERVER = "localhost";

const API_URL =
  (API_PORT === 443 ? "https://" : "http://") +
  API_SERVER +
  ":" +
  API_PORT +
  "/api/flota/";

const dsflotamaq = async (_PlacaSerie, _Tipo, _IdSucursal, _Estado) => {
  try {
    const params = {
      PlacaSerie: _PlacaSerie,
      Tipo: _Tipo,
      Sucursal: _IdSucursal,
      Estado: _Estado,
    };
    // console.log(params);
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    // /api/flota/flotamaq
    const res = await axios.get(API_URL + "flotamaq", { params, headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const put_bitacora = async (
  Modo,
  PlacaSerie,
  FecInicio,
  KmsInicio,
  FecTermino,
  KmsTermino,
  CargaComLts,
  CargaComKms,
  Temperatura,
  Observacion,
  Estado,
  IdChofer,
  IdDigitador,
  UsoAco,
  UsoEnt,
  UsoVar,
  Costo,
  Venta,
  IdCostoVenta
) => {
  try {
    // Parámetros de la solicitud PUT
    const params = {
      Modo: Modo,
      PlacaSerie: PlacaSerie,
      FecInicio: FecInicio,
      KmsInicio: KmsInicio,
      FecTermino: FecTermino,
      KmsTermino: KmsTermino,
      CargaComLts: CargaComLts,
      CargaComKms: CargaComKms,
      Temperatura: Temperatura,
      Observacion: Observacion,
      Estado: Estado,
      IdChofer: IdChofer,
      IdDigitador: IdDigitador,
      UsoAco: UsoAco,
      UsoEnt: UsoEnt,
      UsoVar: UsoVar,
      Costo: Costo,
      Venta: Venta,
      IdCostoVenta: IdCostoVenta,
    };
    // console.log(params);
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.put(API_URL + "putbitacora", params, { headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const bdService = {
  dsflotamaq,
  put_bitacora,
};

export default bdService;
